import React, { useState, useEffect, useRef } from 'react';
import './index.scss';

export default function AudioModal(props) {
  const [play, setPlay] = useState(false);
  const [playSrc, setPlaySrc] = useState(null);
  let w = Math.floor(props.data.file.dur / 1000);
  w = w > 100 ? 100 : w;
  w += 30;
  const vadioElement = useRef(null);
  //音频播放
  const playAudio = (event) => {
    if (play) {
      audioEnded();
    } else {
      setPlay(true);
      setPlaySrc(props.data.file.mp3Url);
    }
    event && event.stopPropagation();
  };
  //音频停止
  const audioEnded = (event) => {
    setPlay(false);
    setPlaySrc(null);
    vadioElement.current.pause();
    event && event.stopPropagation();
  };
  useEffect(() => {
    if (play && playSrc) {
      vadioElement.current.play();
    }
  }, [play, playSrc]);
  return (
    <span className="audio-control" onClick={playAudio}>
      <span className="audio-icon" style={{ width: `${w}px` }}>
        <span className={play ? 'nim-audio hover' : 'nim-audio'}>
          <audio
            style={{ display: 'none' }}
            src={playSrc}
            onPause={audioEnded}
            onEnded={audioEnded}
            ref={vadioElement}
          />
          <i className={play ? 'play' : null} />
        </span>
      </span>
      <span className="audio-time">
        {Math.floor(props.data.file.dur / 1000)}〃
      </span>
    </span>
  );
}
